export default __webpack_public_path__ + "static/media/email.4a3a2c6a.svg";